import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { LtmsDataSource } from 'src/app/shared/services/lw-ui-rule/ltms-data-source';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { NgIf, NgFor } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { LitmusComponentsModule } from 'src/app/litmus-components/litmus-components.module';

@Component({
    selector: 'action-edit-modal',
    templateUrl: './action-edit-modal.component.html',
    styleUrl: './action-edit-modal.component.scss',
    imports: [NgIf, NgFor, LtmsLoaderComponent, LitmusComponentsModule]
})
export class ActionEditModalComponent implements OnChanges {
  @Input() configs: any = {}
  @Output() onCancel = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Output() onUpdate = new EventEmitter<any>()
  fieldToRender: any = []
  columnsToEdit: any = []
  dataToEdit: any = {}
  showEditModal: boolean = false;
  modalConfigs: any = {}
  brandDetails: any = {}
  isDataPrepared: boolean = false;
  fieldsToUpdate: any = {}
  fieldsToUpdateClone: any = {}

  constructor(
    private _dataSource: LtmsDataSource,
    private _feedService: FeedsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['configs']) {
      this.modalConfigs = this.configs;
      this.fieldToRender = _.get(this.configs, 'fieldDefinitions');
      this.dataToEdit = _.get(this.configs, 'dataToEdit');
      this.brandDetails = _.get(this.configs, 'brandDetails');
    }
    this.renderModal()
  }

  renderModal() {
    this.isDataPrepared = false;
    if (!_.isEmpty(this.fieldToRender) && !_.isEmpty(this.dataToEdit)) {
      this.showEditModal = true
      this.prepareFieldDetails();
    } else {
      this.showEditModal = false;
      console.warn("Reuired parameter not found to render modal")
    }
  }

  prepareFieldDetails() {
    let issueDetail = _.get(this.modalConfigs, 'issueDetail')
    issueDetail.tags = Helpers.deepClone(this.dataToEdit);
    var apiParams = {
      "brandId": this.brandDetails._id,
      "issueId": this.dataToEdit.row_id,
      "issueDetail": issueDetail
    }

    let promises: any = []
    var promiseMap = {};
    _.each(this.fieldToRender, (customField: any) => {
      if (true) {
        var promise = this._dataSource.getData(customField, apiParams);
        promises.push(promise.then((success: any) => {
          promiseMap[customField["field_id"]] = success;
          return success;
        }, (error) => {
          return { "data": "", "errorOn": customField }
        }))
      }
    })

    Promise.all(promises).then((promise) => {
      _.each(this.fieldToRender, (customField: any, index: any) => {
        if (true) {
          customField["values"] = promiseMap[customField["field_id"]]["data"] || promise[index]["data"];
          if (promise[index]["prefillValue"] || promiseMap[customField["field_id"]]["prefillValue"]) {
            customField["prefillValue"] = promiseMap[customField["field_id"]]["prefillValue"] || promise[index]["prefillValue"];
          } else {
            customField["prefillValue"] = null;
          }
          if (customField.data_type == 'list') {
            customField.elementType = 'list'
            let selectedOption: any = {}
            if (_.get(customField, 'datasource.options.isAjax') != true) {
              customField.props = this.getDropDownOption(customField);
              // if (_.has(customField, 'props.options') && !_.isEmpty(customField.props.options) && customField["prefillValue"]) {
              //   selectedOption = _.find(customField.props.options, { value: customField["prefillValue"] });
              //   if (!_.isEmpty(selectedOption)) {
              //     customField.selectedOption = selectedOption
              //   }
              // }
            } else {
              customField.props = this.getSelect2AjaxData(customField)
            }

            if (_.get(customField, 'datasource.options.data_to_save_in.display_field') && _.get(customField, 'datasource.options.data_to_save_in.value_field')) {
              const dataSaveIn = _.get(customField, 'datasource.options.data_to_save_in');
              if (this.dataToEdit[dataSaveIn.value_field] && this.dataToEdit[dataSaveIn.display_field]) {

                selectedOption = {
                  value: this.dataToEdit[dataSaveIn.value_field],
                  name: this.dataToEdit[dataSaveIn.display_field]
                }

                if (customField.is_cell_modify) {
                  let selectedValues: any = {}
                  this.fieldsToUpdate[dataSaveIn.value_field] = selectedValues[dataSaveIn.value_field] = this.dataToEdit[dataSaveIn.value_field]
                  this.fieldsToUpdate[dataSaveIn.display_field] = selectedValues[dataSaveIn.display_field] = this.dataToEdit[dataSaveIn.display_field]
                  this.fieldsToUpdate[customField.field_id] = [selectedValues]

                }

              }


            } else if (this.dataToEdit[customField.field_id]) {
              selectedOption = {
                value: this.dataToEdit[customField.field_id],
                name: this.dataToEdit[customField.field_id]
              }
              if (customField.is_cell_modify) {
                this.fieldsToUpdate[customField.field_id] = this.dataToEdit[customField.field_id]
              }
            }
            customField.props.selectedOption = selectedOption
            customField.selectedOption = selectedOption;




          } else if (customField.data_type == 'date' || customField.data_type == 'datetime') {
            customField.elementType = 'date-picker'
            customField.props = {
              restriction: {
                from: (_.get(customField, "dom_options.disable_back_date")) ? moment(new Date()).format("YYYY/MM/DD") : "1969/12/31",
              },
              type: customField.data_type,//'date',
              format: _.get(customField, 'dom_options.format', 'DD-MM-YYYY'),
            }
            if (customField.is_cell_modify) {
              this.fieldsToUpdate[customField.field_id] = this.dataToEdit[customField.field_id]
            }

          } else if (customField.data_type == 'string' || customField.data_type == 'number') {
            customField.elementType = 'input';
            if (customField?.dom_options?.type == 'single-line') {
              customField.type = 'text';
            } else if (customField?.dom_options?.type == 'multi-line') {
              customField.type = 'textarea';
            } else if (customField.data_type == 'number') {
              customField.type = 'number';
            }
            if (customField.is_cell_modify) {
              this.fieldsToUpdate[customField.field_id] = this.dataToEdit[customField.field_id]
            }
          } else {
            customField.elementType = 'label'
          }

        }
        this.fieldsToUpdateClone = Helpers.deepClone(this.fieldsToUpdate);

        this.columnsToEdit.push(customField);
        if (this.fieldToRender.length === this.columnsToEdit.length) {
          this.isDataPrepared = true
        }
      })
    })
  }

  getDropDownOption(param: any) {
    let props: any = {
      options: [],
      placeholder: "Select " + (param['display_name'] || param["name"])
    }
    if (param["values"] && param["values"].length) {
      if (_.get(param, "datasource.type") == 2 || _.get(param, "datasource.type") == 3) {
        var value_field = param["datasource"]["options"]["value_field"];
        var display_field = param["datasource"]["options"]["display_field"];
        _.each(param["values"], (value) => {
          props.options.push({
            name: value[display_field],
            value: value[value_field]
          })
        });
      } else if (true) {

        _.each(param["values"], (value) => {
          props.options.push({
            name: (_.isObject(value)) ? value["value"][value["label_field"]] : value,
            value: (_.isObject(value)) ? value["value"][value["value_field"]] : value
          });
        });
      }
    }
    return props;
  }

  getSelect2AjaxData(param) {
    var url = _.get(param, "datasource.options.url");
    var limit = _.get(param, "datasource.options.limit") || 10;

    // Fetch the value's key which has to be the id of select option
    var id = _.get(param, "datasource.options.value_field");
    // Fetch the key which has to be picked from the response for the text of the select option
    var text = _.get(param, "datasource.options.display_field");
    // Fetch the key which has to be picked from the response for the name of the select option
    var name = _.get(param, "datasource.options.name_field");

    var method = _.get(param, "datasource.options.method");
    var isPostMethod = false;
    if (method == "POST" || method == "post") {
      isPostMethod = true;
    }
    // var selectedValues = this._getDropdownData(param.field_id, _.get(param, "group_options.group_id"), _.get(param, "group_options.index"))
    var query = {
      "page_number": 1,
      "limit": limit,
      "format": 'json'
    }

    let ajaxParams = {
      // "selectedOption": selectedValues,
      placeholder: "Please search and select",
      searchfield: "search_text",
      options: [],
      isDisabled: false,
      api: {
        url: url,
        method: (method) ? method : "get",
        parser: (data: any) => {
          if (_.get(param, "datasource.options.data.parallel_aggs")) {
            return this.getResultFromParallelAggs(param, data);
          } else {
            // key_to_pick_from_response: This will return the nested path separated through '.' which needs to be fetched from the api response.
            var keyToPickFromResponse = _.get(param, "datasource.options.key_to_pick_from_response");
            var response = _.get(data, keyToPickFromResponse) || data[keyToPickFromResponse];

            if (response && response.length) {
              return _.map(response, (d: any) => {
                // if (selectedValues && selectedValues.length) {
                //   var selectedValue = _.filter(selectedValues, { "id": d[id] })
                //   if (!selectedValue) {
                //     return ({ "id": d[id], "value": d[id], "text": d[text], "name": d[text], "name_1": d[name] })
                //   }
                // }

                return ({ "id": d[id], "value": d[id], "text": d[text], "name": d[text], "name_1": d[name] })

              });
            } else {
              return []
            }
          }
        },
        paramters: Object.assign(query, _.get(param, "datasource.options.data"))
      }
    }
    return ajaxParams;
  }

  getResultFromParallelAggs(param, response) {
    var keyToPickFromResponse = _.get(param, "datasource.options.key_to_pick_from_response");
    var data = _.get(response, keyToPickFromResponse) || response[keyToPickFromResponse];
    var hasMultipleKeys = !_.isEmpty(data) && Object.keys(data) && Object.keys(data).length > 1;

    if (_.isEmpty(data)) {
      return []
    } else if (hasMultipleKeys) {
      var results: any = [];
      var children: any = [];
      for (var respKey in data) {
        children = [];
        for (var managerKey in data[respKey]) {
          children.push({
            "id": managerKey,
            "text": managerKey
          })
        }
        results.push({
          "text": this.getHierarchyNameByLevel(respKey),
          "children": children
        })
      }
      return results;
    } else {
      var results: any = [];
      for (var respKey in data) {
        for (var managerKey in data[respKey]) {
          results.push({
            "id": managerKey,
            "text": managerKey + " (" + data[respKey][managerKey] + ")"
          })
        }
      }
      return results;
    }
  }

  getHierarchyNameByLevel(level) {
    var hierarchyDetail: any = null;
    var levelIndex: any = null;
    var hierarchyName: any = null;
    for (let hierarchyKey in this.brandDetails.hierarchy_list_alias) {
      hierarchyDetail = this.brandDetails.hierarchy_list_alias[hierarchyKey];
      if (level.indexOf(hierarchyDetail.name) >= 0) {
        hierarchyName = hierarchyKey;
        levelIndex = (hierarchyDetail.values).indexOf(level);
      }
    }
    return _.get(this.brandDetails, "hierarchy_list." + hierarchyName + '.' + levelIndex);
  }

  updateValue(event: any, customField: any) {
    const data: any = event.detail
    if (customField.is_cell_modify) {
      if (!_.isEmpty(data) && _.get(customField, 'datasource.options.data_to_save_in.display_field') && _.get(customField, 'datasource.options.data_to_save_in.value_field')) {
        let selecetedValues: any = {}
        const dataSaveIn = _.get(customField, 'datasource.options.data_to_save_in');
        if (data.name && data.value) {
          this.fieldsToUpdate[dataSaveIn.display_field] = selecetedValues[dataSaveIn.display_field] = data.name;
          this.fieldsToUpdate[dataSaveIn.value_field] = selecetedValues[dataSaveIn.value_field] = data.value;
          this.fieldsToUpdate[customField.field_id] = [selecetedValues]
        }
      } else {
        this.fieldsToUpdate[customField.field_id] = data
      }
    }

  }
  enableUpdateButton() {
    return (this.generateHash(this.fieldsToUpdateClone) != this.generateHash(this.fieldsToUpdate))
  }

  private generateHash(obj): string {
    if (obj !== undefined && !_.isEmpty(obj)) {
      return _.map(obj, (val, key) => { return `${key}-${JSON.stringify(val)}` }).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }

  closeEditModal() {
    this.onClose.emit()
  }

  cancel() {
    this.onCancel.emit()
  }

  updateData() {
    if (!_.isEmpty(this.fieldsToUpdate)) {
      this._feedService.updateCustomParameter(this.dataToEdit.row_id, { "customFeed": this.fieldsToUpdate }).subscribe((response: any) => {
        if (response.code == 0 && response.data.code == 0) {
          Helpers.smallAlertBox("Success", "Action updated successfully. Updated details may take some time to reflect.", "success");
        } else if (response.code == 0 && response.data.code == 4 || response.data.code == 4022) {
          Helpers.smallAlertBox("Warning", "Data already updated.", "warn");
        } else {
          Helpers.smallAlertBox("Error", "Error occured while updating the row.", "error");
        }
        this.onUpdate.emit(this.fieldsToUpdate);
      }, (error: any) => {
        Helpers.smallAlertBox("Error", "Error occured while updating the row.", "error");
        this.onUpdate.emit(this.fieldsToUpdate);
      })
    }
  }



  isScrollEnabled() {
    const el = document.getElementById('action-edit-modal-body');
    if (el) {
      return (el.offsetHeight < el.scrollHeight)
    } else {
      return false
    }
  }

}
